import { render, staticRenderFns } from "./CollectionSimpleCard.vue?vue&type=template&id=6e0d4a8b&scoped=true"
import script from "./CollectionSimpleCard.vue?vue&type=script&lang=js"
export * from "./CollectionSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./CollectionSimpleCard.vue?vue&type=style&index=0&id=6e0d4a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d4a8b",
  null
  
)

export default component.exports